import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H5 } from 'foundations-components/transitional/components/H5';
import { Button } from 'foundations-components/transitional/components/Button';
import { AddIcon } from 'foundations-assets';
import DomainExistingValue from './DomainExistingValue';
import DomainNewValue from './DomainNewValue';
import PropertyInputMultiplePropertyPopoverBody from '../PropertyInputMultiplePropertyPopoverBody';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function PopoverContent({
  domains,
  onChangeDomain,
  onAddDomain,
  onRemoveDomain,
  onPromoteDomain,
  showAutoSaveText,
  onExistingDomainInputBlur,
  onExistingDomainInputFocus
}) {
  const [showNewDomainInput, setShowNewDomainInput] = useState(false);
  const handleAddNewDomainInput = () => setShowNewDomainInput(true);
  const handleCancelNewDomainInput = () => setShowNewDomainInput(false);
  const handleSaveNewDomain = newDomain => {
    onAddDomain(newDomain);
    setShowNewDomainInput(false);
  };
  const renderDomainInput = (domain, index) => {
    const isPrimaryDomain = index === 0;
    return /*#__PURE__*/_jsx(ListItem, {
      marginBlockEnd: "200",
      children: /*#__PURE__*/_jsx(DomainExistingValue, {
        autoFocus: isPrimaryDomain,
        onChange: evt => onChangeDomain(index, evt.target.value),
        showError: true,
        value: domain,
        isPrimaryDomain: isPrimaryDomain,
        onRemoveDomain: onRemoveDomain,
        onPromoteDomain: onPromoteDomain,
        onBlur: onExistingDomainInputBlur,
        onFocus: onExistingDomainInputFocus
      })
    }, index);
  };
  const addNewDomainButton = /*#__PURE__*/_jsxs(Button, {
    use: "transparent",
    onClick: handleAddNewDomainInput,
    paddingInlineStart: "0",
    children: [/*#__PURE__*/_jsx(AddIcon, {
      size: "300",
      color: "do-not-use-calypso-dark"
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataProperties.PropertyInputMultipleDomain.addDomain"
    })]
  });
  return /*#__PURE__*/_jsxs(PropertyInputMultiplePropertyPopoverBody, {
    children: [/*#__PURE__*/_jsx(H5, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataProperties.PropertyInputMultipleDomain.label"
      })
    }), /*#__PURE__*/_jsxs(List, {
      children: [domains.map(renderDomainInput), showNewDomainInput && /*#__PURE__*/_jsx(DomainNewValue, {
        domains: domains,
        onSave: handleSaveNewDomain,
        onCancel: handleCancelNewDomainInput,
        showAutoSaveText: showAutoSaveText
      })]
    }), addNewDomainButton]
  });
}
export default PopoverContent;